import { render, staticRenderFns } from "./UserAssetList.vue?vue&type=template&id=de62b296&"
import script from "./UserAssetList.vue?vue&type=script&lang=js&"
export * from "./UserAssetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports